import { get, post } from '@/plugins/axios.js'

// 如果我们的项目需要代理多个地址，就不能在axios中设置 axios.defaults.baseURL
// 应该在此处动态的拼接url！
const baseApi = process.env.VUE_APP_BASE_API
const hyitf = process.env.VUE_APP_HYITF

const demo = {
  /**
   * get请求
   * @param {Object} options 参数，例如：{a:'a',b:'b'}
   * @returns
   */
  getData (options) {
    return get(`${baseApi}/data/shorttime/gz_shorttime.json`, options)
  },

  /**
   * post请求
   * @param {Object} options 参数，例如：{a:'a',b:'b'}
   * @returns
   */
  postData (options) {
    return post(`${hyitf}/data/lightningNew`, options)
  },

  /**
   * 获取测试数据
   */
  getTestData (options) {
    return get('/testData/GDBY_shorttime.json', options)
  }
}
export default demo
